export default {

  getJwtToken() {
    return localStorage.getItem('uid');
  },

  setJwtToken(token) {
    if (token) {
      localStorage.setItem('uid', token);
    } else {
      localStorage.removeItem('uid');
    }
  },

}
